import React, { useState, useCallback, useEffect } from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import { CMS } from "helpers/viewContent";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import * as Yup from "yup";
import { viewCms_, updateCms_ } from "store/services/pagesService";

//imported
import * as Path from "routes/paths";
import * as actions from "store/actions/index.js";
const editorConfiguration = {
  toolbar: [
    "heading",
    "|",
    "bold",
    "italic",
    "link",
    "|",
    "bulletedList",
    "numberedList",
    "|",
    "blockQuote",
    "insertTable",
    "|",
    "mediaEmbed",
    "imageInsert",
    "fileBrowser",
    "exportPdf",
    "exportWord",
    "exportXml",
    "|",
    "undo",
    "redo",
  ],
  sourceEditing: {
    preview: true, // Enable the preview feature
    highlightActiveLine: true, // Enable highlighting the line the cursor is on
    highlightMatches: true, // Enable highlighting matching tag pairs
  },
};
const AddEdit = ({ dispatch, match }) => {
  const validationSchema = Yup.object().shape({
    title: Yup.string().required("Title is required"),
    slug: Yup.string().required("Slug is required"),
  });
  let slugUrl = match?.params?.key;

  const validateData = async (data) => {
    try {
      await validationSchema.validate(data, { abortEarly: false });
      return { isValid: true, errors: {} };
    } catch (error) {
      const errors = {};
      error.inner.forEach((err) => {
        errors[err.path] = err.message;
      });
      return { isValid: false, errors };
    }
  };
  const history = useHistory();
  const [isShow, setIsShow] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [fieldValue, setFieldValue] = useState(null);
  const [fields, setfields] = useState({
    title: "",
    slug: "",
    description: fieldValue ? fieldValue : "",
  });

  const handleChange = useCallback(
    (name) => (evt) => {
      setfields((prevState) => ({
        ...prevState,
        [name]: evt.target.value,
      }));
      setValidationErrors((prevErrors) => ({ ...prevErrors, [name]: "" }));
    },
    []
  );

  //submit setting data
  const handleSubmit = async (evt) => {
    try {
      evt.preventDefault();
      const validation = await validateData(fields);
      if (validation.isValid) {
        let obj = {
          ...fields,
          description: fieldValue,
        };
        setIsShow(true);
        setIsShow(false);
        console.log(obj, "obj");
        await dispatch(updateCms_(slugUrl, obj));
        history.push(Path.cms);
      } else {
        setValidationErrors(validation.errors);
      }
    } catch (err) {
      setIsShow(false);
      console.log(err);
    }
  };

  async function getDataView() {
    try {
      dispatch(actions.persist_store({ loader: true }));
      let res = await dispatch(viewCms_(slugUrl));
      setfields(res?.body);
      setFieldValue(res?.body?.description);
      dispatch(actions.persist_store({ loader: false }));
    } catch (err) {
      dispatch(actions.persist_store({ loader: false }));
      console.log(err);
    }
  }
  useEffect(() => {
    if (slugUrl) {
      getDataView();
    }
  }, []);

  return (
    <>
      <Helmet title={CMS.CURRENT_MODULE} />
      <div className="page-header">
        <h3 className="page-title">
          <span className="page-title-icon bg-gradient-primary text-white me-2">
            <i className="mdi mdi-table-large menu-icon"></i>
          </span>{" "}
          {CMS.CURRENT_MODULE}
        </h3>
        <nav aria-label="breadcrumb">
          <ol className="breadcrumb">
            <li className="breadcrumb-item">
              <Link to={Path.cms}>{CMS.CURRENT_MODULE}</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {slugUrl ? "Edit" : "Add"}
            </li>
          </ol>
        </nav>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <h4 className="card-title">{slugUrl ? "Edit" : "Add"} Content</h4>
              <form className="forms-sample" onSubmit={handleSubmit}>
                <div className="form-group">
                  <label for="exampleInputName1">Title*</label>
                  <input
                    type="text"
                    className="form-control"
                    id="exampleInputName1"
                    placeholder="Title"
                    name="title"
                    onChange={handleChange("title")}
                    value={fields.title}
                  />
                  {validationErrors.title && (
                    <div className="text-danger err">
                      {validationErrors.title}
                    </div>
                  )}
                </div>
                <div className="form-group">
                  <label for="exampleInputName1">Slug*</label>
                  <div className="col-md-12">
                    <select
                      className="form-select"
                      name="key"
                      onChange={handleChange("slug")}
                      value={fields.slug}
                      disabled
                    >
                      <option value="">Select </option>
                      <option
                        value="term-conditions"
                        selected={
                          fields.slug === "term-conditions" ? "selected" : ""
                        }
                      >
                        Terms & Conditions{" "}
                      </option>
                      <option
                        value="about-us"
                        selected={fields.slug === "about-us" ? "selected" : ""}
                      >
                        About Us
                      </option>
                      <option
                        value="privacy-policy"
                        selected={
                          fields.slug === "privacy-policy" ? "selected" : ""
                        }
                      >
                        Privacy Policy
                      </option>
                      <option
                        value="help-support"
                        selected={
                          fields.slug === "help-support" ? "selected" : ""
                        }
                      >
                        Help Support
                      </option>
                    </select>
                    {validationErrors.slug && (
                      <div className="text-danger err">
                        {validationErrors.slug}
                      </div>
                    )}
                  </div>
                </div>
                <div className="form-group">
                  <label for="exampleTextarea1">Description*</label>
                  <CKEditor
                    editor={ClassicEditor}
                    config={editorConfiguration}
                    data={fields.description}
                    onChange={(event, editor) => {
                      const data = editor.getData();
                      // console.log( { event, editor, data } );
                      setFieldValue(editor.getData());
                    }}
                    className="ckeditor-control ckeditor-custom-height"
                  />
                  {fieldValue == null && (
                    <div className="text-danger err">
                      Description is required
                    </div>
                  )}
                </div>

                <button
                  type="submit"
                  disabled={isShow ? true : false}
                  className="btn btn-gradient-primary me-2"
                >
                  {isShow ? "Loading.." : "Submit"}
                </button>
                <Link to={Path.cms}>
                  <button className="btn btn-outline-secondary btn-lg">
                    Back
                  </button>
                </Link>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
const mapStateToPros = (state) => {
  return {};
};
function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(mapStateToPros, mapDispatchToProps)(AddEdit);
